<p>logs-email-log works!</p>
